import { render, staticRenderFns } from "./FaqForm.vue?vue&type=template&id=a2ef16ec&scoped=true"
import script from "./FaqForm.vue?vue&type=script&lang=js"
export * from "./FaqForm.vue?vue&type=script&lang=js"
import style0 from "./FaqForm.vue?vue&type=style&index=0&id=a2ef16ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ef16ec",
  null
  
)

export default component.exports